import React from "react";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import { useTranslation, Trans } from "react-i18next";

import "css/stepper.css";
import Tooltip from "components/General/Tooltip";

const Stepper = ({ status, setOpenChatWindow }) => {
  const { t } = useTranslation();
  const steps = ["Initiated", "Pending", "Closed"];

  const renderToolTip = (step) => {
    if (status === "Pending" && step === "Pending") {
      return (
        <Tooltip
          xMargin="mx-0"
          content={t("CustomerServices-tooltip-pending")}
        />
      );
    } else if (
      (status === "Closed" || status === "Processed") &&
      (step === "Closed" || step === "Processed")
    ) {
      return (
        <Tooltip
          xMargin="mx-0"
          content={
            <Trans
              i18nKey="CustomerServices-tooltip-completed"
              components={{
                link1: (
                  <a
                    className="underline text-theme-action"
                    onClick={() => setOpenChatWindow(true)}
                  ></a>
                ),
              }}
            />
          }
        />
      );
    }
  };

  const renderStatus = (step) => {
    if (step === "Initiated") {
      return <TiTick size={20} color={"#007bc1"} />;
    } else if (status === "Pending" && step === "Pending") {
      return <GoDotFill size={20} color={"#007bc1"} />;
    } else if (
      status === "Closed" ||
      status === "Processed" ||
      status === "Completed"
    ) {
      return <TiTick size={20} color={"#007bc1"} />;
    }
  };

  return (
    <>
      <div className="flex justify-center my-7">
        {steps?.map((step, i) => (
          <div
            key={i}
            className={`step-item
              ${status === "Pending" && "active"} ${
              (status === "Closed" ||
                status === "Processed" ||
                step === "Initiated") &&
              "complete"
            }
          `}
          >
            <div className="step">{renderStatus(step)}</div>
            <p className="text-gray-500 pt-2">
              {step}
              {step !== "Initiated" && renderToolTip(step)}
            </p>
          </div>
        ))}
      </div>
    </>
  );
};

export default Stepper;
